<template lang="html">
  <div class="row encounter-slide">
    <div v-if="treatment_plan" class="tp-title col-12">
      <h5><strong>{{ treatment_plan.Heading }}</strong></h5>
      <p><em>
        treatment plan prepared 
        <span v-if="pat_name">for {{ pat_name }}</span> 
        <span v-if="treatment_plan.SecDateTEdit"> on {{ treatment_plan.SecDateTEdit | prettyDateShortFromDT }}</span>
      </em></p>
    </div> <!-- /.tp-title -->

    <div class="slide-body col-10 offset-1">
      
      <div class="row row-treatment-header align-items-center">
        <div class="col-8">
          <h3>Treatment Part 1</h3>
          <h1>Get Advancing Disease Under Control</h1>
          <h5>
            urgent treatment that can't wait.<br>
            like a house fire, the damage gets worse until you stop it.
          </h5>
        </div> <!-- /.col-8 -->
        <div class="col-4">
          <img class="img-fluid" src="../assets/img/icon-advancing-path.png" alt="illustration of a house on fire" />
        </div> <!-- /.col-4 -->
      </div> <!-- /.row -->

      <hr class="hr-dark-color" />

      <h3><strong>We need to keep disease from growing:</strong></h3>

      <ul class="ul-procedures">
        <li v-for="proc in procsFiltered" :key="proc.ProcNum" v-if="proc.ProcCode !== '10%sameday'">
          <span v-if="encounterData.locationProcCats[`${proc.ProcCode}`] && encounterData.locationProcCats[`${proc.ProcCode}`].friendly_desc" class="desc-friendly"> {{ encounterData.locationProcCats[`${proc.ProcCode}`].friendly_desc }}</span>
          <span class="desc" v-else>{{ proc.Descript }}</span>
          <span v-if="proc.ToothNumTP" class="tooth">, tooth: {{ proc.ToothNumTP }}</span>
        </li>
      </ul>

      <hr class="hr-dark-color" />
      
      <h5><i class="fas fa-usd-circle"></i> <strong>Save Money By Avoiding Bigger Procedures Later</strong></h5>
      
      <hr class="hr-dark-color" />
      <p class="text-center"><button @click.prevent="markSlideAndForward" class="btn btn-green btn-lg">Got it &mdash; Control first!<i class="fas fa-angle-right fa-fw"></i></button></p>
    </div> <!-- /.slide-body -->

  </div> <!-- /.encounter-slide -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ImageGallery from '../components/ImageGallery.vue'

export default {
  props: ['encounterData'],
  components: {
    ImageGallery,
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
    procsFiltered() {
      if(this.encounterData.treatPlanData && this.encounterData.treatPlanData.length && this.encounterData.locationProcCats) {
        return this.encounterData.treatPlanData.filter(tp => this.encounterData.locationProcCats[`${tp.ProcCode}`] && (this.encounterData.locationProcCats[`${tp.ProcCode}`]=="advancing" || this.encounterData.locationProcCats[`${tp.ProcCode}`].category_code=="advancing")).sort(this.sortByPriority);
      }
      return null;
    },
  },
  watch: {
    
  },
  methods: {
    markSlideAndForward() {
      // this.$emit('update-encounter-data', {
      //   slides_completed: [
      //     ...this.encounterData.slides_completed,
      //     this.$route.name,
      //   ],
      // });
      this.$emit('forward')
    },
    // used in procsFiltered
    sortByPriority(prev,next){
      const pPri = prev.priority.toUpperCase() || null;
      const nPri = next.priority.toUpperCase() || null;
      if(!nPri) {
        return -1;
      }
      if(!pPri) {
        return 1;
      }
      // ascending
      // can't compare strings with subtraction here
      if(pPri < nPri) {
        return -1;
      }
      if(pPri > nPri) {
        return 1;
      }
      return 0;
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

h1 {
  margin-bottom: 20px;
}
.tp-title {
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid @dark-color;
  margin-bottom: 30px;

  h5,p {
    margin: 0;
  }
}
h5 {
  margin-bottom: 30px;
}
.encounter-slide {
  padding: 0;
}
.slide-body {
  padding: 30px;
}
hr {
  margin: 30px 0;
}
.row-treatment-header {
  h1,h3,h5 {
    font-weight: bold;
  }
}
</style>
